import { useParams } from "react-router-dom";
import useAppContext from "../../../hooks/useAppContext";
import FullPageLoader from "../../../components/loaders/FullPageLoader";
import { RecognizedHeading } from "../../../types/messages";
import ParsedHtml from "./ParsedHtml";
import { useMount } from "react-use";
import { comparisonDetailStyle, cardClass } from "./styles";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { mergeStyles } from "@fluentui/merge-styles";
import React from "react";

const emptyClasses = mergeStyles({
  // "&:hover": {
  //   boxShadow: "2px 1px 4px rgba(0,0,0, 0.3)",
  // },
  paddingLeft: 10,
  paddingRight: 10,

});



const ComparisonDetail = () => {
  const params = useParams();
  const { getAttachment, initialLoading } = useAppContext();

  const { attachmentId, recognizedSegmentIndex, recognizedHeadingIndex } = params;

  const attachment = getAttachment(attachmentId);
  const appInsights = useAppInsightsContext();
  const { useState } = React;
  const [visible, setVisible] = useState(false);
  useMount(() => {
    appInsights.trackPageView({ name: "Comparison summary" });
  });

  if (initialLoading) {
    return <FullPageLoader title="Analysis loading..." />;
  }

  const recognizedHeadings: RecognizedHeading =
    attachment.recognizedSegments[recognizedSegmentIndex].recognizedHeadings[recognizedHeadingIndex];

  const recognizedReferences: Array<any> = recognizedHeadings.recognizedReferencesCount
    ? recognizedHeadings.recognizedReferences
    : [];

    return (
    <div className={comparisonDetailStyle}>
      <ParsedHtml htmlString={recognizedHeadings.recognizedText}></ParsedHtml>
      {recognizedReferences.length > 0 && (
        <>
        <div className={`${cardClass} ${emptyClasses}`} onClick={() => setVisible(!visible)}>
          <p><b>Used in {recognizedHeadings.recognizedReferencesCount} {recognizedReferences.length === 1 ? "paragraph:" : "paragraphs:"}</b></p>
          {visible && (
          <div>
            {recognizedReferences.map((reference): any => {
              return <ParsedHtml htmlString={reference}></ParsedHtml>;
            })}
          </div>)}
          </div>
        </>
      )}
    </div>
  );
};
export default ComparisonDetail;
